import React, { Component } from 'react';
import { Container, Card, Table, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { POST } from '../../api';

class ChangePassword extends Component {

    state = {
        old_pass: '',
        new_pass: '',
        confirm_new_pass: '',
        isLoading: false,
    };

    handlePasswordChange = async () => {
        try {
            if (!this.state.old_pass.trim()) {
                toast.error(t('Old Password is required'));
                return;
            }

            if (!this.state.new_pass.trim()) {
                toast.error(t('New Password is required'));
                return;
            }

            if (!this.state.confirm_new_pass.trim()) {
                toast.error(t('Confirm New Password is required'));
                return;
            }

            // Set loading state
            this.setState({ isLoading: true });

            const formData = new FormData();
            formData.append('password1', this.state.old_pass);
            formData.append('password2', this.state.new_pass);
            formData.append('password3', this.state.confirm_new_pass);
            formData.append('parent_id', this.props.authData.userData.parent_id);
            formData.append('user_id', this.props.authData.loginData.user_id);

            const res = await POST('password/change-password', formData);

            if (res.data.type === false) {
                toast.error(t(res.data.message));
            } else {
                toast.success(t(res.data.message));
                this.setState({
                    old_pass: '',
                    new_pass: '',
                    confirm_new_pass: ''
                });
            }
        } catch (err) {
            console.log(err);
            toast.error(t('Something went wrong!'));
        } finally {
            // Reset loading state
            this.setState({ isLoading: false });
        }
    }


    render() {

        return (
            <Container fluid>
                <div id='iedu-layout'>
                    <NavBar />
                    <div id='page-content'>
                        <Header lite={true} heading={t('Change Password')} backBtn={true} />
                        <div className='ps-2'>
                            <Row>
                                <Col md={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('Old Password')}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={this.state.old_pass}
                                            onChange={(e) => this.setState({ old_pass: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('New Password')}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={this.state.new_pass}
                                            onChange={(e) => this.setState({ new_pass: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Form.Group className="mb-4">
                                        <Form.Label>{t('Confirm New Password')}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={this.state.confirm_new_pass}
                                            onChange={(e) => this.setState({ confirm_new_pass: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button
                                onClick={this.handlePasswordChange}
                                disabled={this.state.isLoading}
                            >
                                {this.state.isLoading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        {t('Saving...')}
                                    </>
                                ) : (
                                    t('Save Password')
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(ChangePassword);
